// extracted by mini-css-extract-plugin
module.exports = {"chip":"_2mbZPyGmPkJG-0s6aeL_3p","chip_type":"_9XV2qAs-sH1CTLEhYoIpa","chip_value":"_29AYV94qyzXKX130673zgJ"};